import { contextFactory } from "../../jsx/context/contextFactory";
import { useInterval, useRepository } from "../../jsx/hook";
import { CustomNotification, NewCustomNotification } from "./Notification";

export type NotificationContext = {
  notifications: CustomNotification[];
  add: (notification: NewCustomNotification) => void;
  remove: (ids: string[]) => void;
};

export const {
  Provider: NotificationProvider,
  useCustomContext: useNotifications,
} = contextFactory<NotificationContext>(function notificationContext() {
  const {
    items: notifications,
    add: localAdd,
    remove,
  } = useRepository<CustomNotification>();

  const add = ({ content, delayInMs }: NewCustomNotification) => {
    const now = new Date();
    const notification: CustomNotification = {
      id: Math.random().toString().substring(2),
      content,
      expireAt: new Date(now.getTime() + delayInMs),
      createdAt: now,
    };
    localAdd(notification);
  };
  useInterval(
    () => {
      const now = new Date();
      const expiredNotifications = notifications.filter(
        ({ expireAt }) => expireAt.getTime() <= now.getTime() - 1000
      );
      remove(expiredNotifications.map(({ id }) => id));
    },
    300,
    [notifications, remove]
  );

  return {
    notifications,
    add,
    remove,
  };
});
